import React, { useState, useEffect } from 'react';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ADMIN_SIDEBAR_ITEMS, DOCUMENTATION_SIDEBAR_ITEMS, SIDEBAR_ITEMS } from './SidebarMenuItems';

export const MainListItems = ({ projectId, open, type, showIcons, onSidebarNavigate }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [submenuOpen, setSubmenuOpen] = useState({});

  const isDashboardPage = location.pathname.includes('/dashboard');

  const isSubmenuActive = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get('view') === param;
  };

  useEffect(() => {
    if (!open) return;
  
    if (isDashboardPage) {
      setSubmenuOpen((prev) => ({
        ...prev,
        home: true,
      }));
    } else {
      setSubmenuOpen((prev) => ({
        ...prev,
        home: false,
      }));
    }
  }, [isDashboardPage, open]);

  const handleItemClick = (item) => {
    if (!open) {
      return navigate(item.url);
    }

    if (item.submenu) {
      if (type !== 'documentation') navigate(item.url);
      setSubmenuOpen((prev) => ({
        ...prev,
        [item.id]: !prev[item.id],
      }));
    } else {
      navigate(item.url);
    }
  };

  const handleSubmenuClick = (param, mainItemUrl) => {
    if (type === 'documentation' && onSidebarNavigate) {
      onSidebarNavigate(param);
    } else {
      const currentParams = new URLSearchParams(location.search);
      currentParams.set('view', param);
      const newUrl = `${mainItemUrl}?${currentParams.toString()}`;
      navigate(newUrl);
    }
  };

  let sidebarItems = [];
  if (type === 'admin-dashboard') {
    sidebarItems = ADMIN_SIDEBAR_ITEMS();
  } else if (type === 'documentation') {
    sidebarItems = DOCUMENTATION_SIDEBAR_ITEMS(); 
  } else {
    sidebarItems = SIDEBAR_ITEMS(projectId);
  }

  return (
    <>
      {sidebarItems.map((item) => (
        <React.Fragment key={item.id}>
          <ListItemButton
            onClick={() => handleItemClick(item)}
            selected={location.pathname === item.url}>
            {showIcons && (
              <Tooltip
                title={item.label}
                placement="right"
                arrow
                disableHoverListener={open}>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  {item.icon}
                </ListItemIcon>
              </Tooltip>
            )}
            {open && <ListItemText primary={item.label} />}
            {item.submenu &&
              open &&
              (submenuOpen[item.id] ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>

          {item.submenu && open && (
            <Collapse in={submenuOpen[item.id]} timeout="auto" unmountOnExit>
              {item.submenu.map((submenuItem) => (
                <ListItemButton
                  key={submenuItem.id}
                  sx={{ pl: 4 }}
                  onClick={() =>
                    handleSubmenuClick(submenuItem.param, item.url)
                  }
                  selected={isSubmenuActive(submenuItem.param)}>
                  <ListItemText
                    primary={
                      <span style={{ fontSize: '14px' }}>
                        {submenuItem.label}
                      </span>
                    }
                    sx={{ 
                      ml: 2, 
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }}
                  />
                </ListItemButton>
              ))}
            </Collapse>
          )}
        </React.Fragment>
      ))}
    </>
  );
};
